function LiContainer({ children }) {
  return <ul>{children}</ul>;
}
export default LiContainer;
